import { render, staticRenderFns } from "./popup-import.vue?vue&type=template&id=0ea12676&scoped=true"
import script from "./popup-import.vue?vue&type=script&lang=js"
export * from "./popup-import.vue?vue&type=script&lang=js"
import style0 from "./popup-import.vue?vue&type=style&index=0&id=0ea12676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea12676",
  null
  
)

export default component.exports